import React from 'react';
import PropTypes from 'prop-types';

import VpButton from '../VpButton';

export const ImportContentButton = ({ setOpen = () => {} }) => {
  return (
    <VpButton variant="text" onClick={() => setOpen(true)}>
      Import Content
    </VpButton>
  );
};

ImportContentButton.propTypes = {
  setOpen: PropTypes.func
};

export default ImportContentButton;



// WEBPACK FOOTER //
// ./src/vp-ui/components/ImportContentButton/ImportContentButton.jsx